exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#timeline-summary-page .summary-title{text-align:center;margin:15px}#timeline-summary-page .summary-title .summary-weekRange{margin:15px 0 10px;font-size:18px}#timeline-summary-page .summary-title span{color:#828282;font-size:15px;font-style:italic}#timeline-summary-page .timeline-summary-cards{display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:1fr;grid-gap:15px;margin:20px}#timeline-summary-page .timeline-summary-cards .card-component{margin:0px;height:100%}#timeline-summary-page .timeline-summary-cards .card-component .card-container{align-items:center;padding:15px 4px;position:relative;justify-content:space-between;height:100%}#timeline-summary-page .timeline-summary-cards .card-component .summary-metricIcon{border-radius:50%;border:1px solid #e0e0e0;width:65px;height:65px;display:flex;align-items:center;justify-content:center;margin-bottom:6px}#timeline-summary-page .timeline-summary-cards .card-component .summary-metricIcon svg{width:40px;height:auto}#timeline-summary-page .timeline-summary-cards .card-component .summary-metric-value{color:#049fda;font-size:36px}#timeline-summary-page .timeline-summary-cards .card-component .summary-metric-name{font-size:14px;color:#828282}#timeline-summary-page .timeline-summary-cards .card-component .summary-metric-unit{font-family:700}#timeline-summary-page .timeline-summary-cards .card-component .summary-metricContent{display:flex;flex-direction:column;align-items:center;flex:1}#timeline-summary-page .timeline-summary-cards .card-component .footer-spacing{margin:36px}#timeline-summary-page .timeline-summary-cards .card-component .summary-metric-footer{display:flex;align-items:end;bottom:15px;margin-top:15px;text-align:center;font-family:700;font-size:12px;color:#333333d9}#timeline-summary-page .timeline-summary-cards .card-component .summary-metric-footer svg{width:28px;margin-bottom:1px}#timeline-summary-page .timeline-summary-cards .card-component .summary-metric-footer svg.error{width:18px;margin-bottom:4px}#timeline-summary-page .timeline-summary-cards .card-component .summary-metric-footer svg.error+span{margin-top:4px}#timeline-summary-page .timeline-summary-cards .card-component .summary-metric-footer svg.data-unavail{width:15px;margin-right:10px}", ""]);

// Exports
exports.locals = {
	"colorTeal": "#54c2b6",
	"colorViolet": "#727cf5",
	"colorTealRedChannel": "84",
	"colorTealGreenChannel": "194",
	"colorTealBlueChannel": "182",
	"colorTealDark": "#26a995",
	"colorTeal50": "rgba(84,194,182,.5)",
	"colorTealScreened": "#54c2b6",
	"colorWhiteOff": "#f2f2f2",
	"colorWhite": "#fff",
	"colorWhiteTrans": "rgba(255,255,255,0)",
	"colorWhite50": "rgba(255,255,255,.5)",
	"colorWarning": "#ea3030",
	"colorWarningLight": "rgba(234,48,48,.15)",
	"colorBlack": "#333",
	"colorGrayDark": "#4f4f4f",
	"colorGray": "#828282",
	"colorGrayLight": "#e0e0e0",
	"colorGrayLight60": "rgba(224,224,224,.6)",
	"colorBlue": "#049fda",
	"colorBlackDark": "#242424",
	"ColorText": "#474747",
	"colorBlueScreened": "#049fda",
	"colorMagenta": "#ea3b7d",
	"colorMagentaScreened": "#ea3b7d",
	"colorYellow": "#fed504",
	"colorYellowDark": "#d8b129",
	"colorYellowScreened": "#fed504",
	"colorUi1": "rgba(4,159,218,.3)",
	"colorUi2": "rgba(84,194,182,.3)",
	"colorUi3": "rgba(234,59,125,.3)",
	"colorUi4": "rgba(254,213,4,.3)",
	"colorUi5": "rgba(31,79,228,.3)",
	"colorUi6": "rgba(177,208,21,.3)",
	"colorUi7": "rgba(228,34,255,.3)",
	"colorUi8": "rgba(255,157,39,.3)",
	"colorUi9": "rgba(66,32,208,.3)",
	"colorUi10": "rgba(26,255,198,.3)",
	"colorUi11": "rgba(205,38,26,.3)",
	"colorUi12": "rgba(247,184,50,.3)",
	"colorUi13": "rgba(146,79,207,.3)",
	"colorUi14": "rgba(98,205,36,.3)",
	"colorUi15": "rgba(255,24,9,.3)",
	"colorUi16": "rgba(207,111,79,.3)",
	"chartLightYellow": "rgba(252,215,34,.7)",
	"chartLightPink": "rgba(250,92,124,.7)",
	"chartLightBlue": "rgba(57,175,209,.7)",
	"fontStyleNormal": "\"robotoregular\",sans-serif"
};